<div class="highlight" *ngIf="config">
  <div class="headers">
    <div class="header1">{{ metadata.label }}</div>
    <div class="header2" *ngIf="!isLatestSales">Guidance</div>
    <div class="header2" *ngIf="isLatestSales && !showAmount">NACHA</div>
  </div>
  <div class="chart" [ngClass]="{'latest-chart': isLatestSales}">
    <div class="element" *ngFor="let item of metadata.elements">
      <div class="concept">
        <span class="dot" [style.background-color]="item.color" *ngIf="isLatestSales"></span>
        {{ item.description }}
      </div>
      <div class="chartAmount" [id]="item.id"></div>
      <div *ngIf="!isLatestSales" class="amount">{{ item.amount }}</div>
    </div>
  </div>
</div>